//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TPhoneValidate from '@/TShareComponent/TPhoneValidate'
import {
  sendPhoneCode,
  checkPhoneCode,
  queryOpenPhoneMessage,
  queryUserInfo,
} from '@/https/user'
import TInput from '@/TShareComponent/TInput'
import { danger } from '@/utils/notify'

export default {
  components: {
    TPhoneValidate,
    TInput,
  },

  data () {
    return {
      formData: {
        phone: '',
        yzm: '',
      },

    }
  },

  created () {
    this.getUserData()
    this.queryConfig()
  },

  methods: {
    async sendPhoneCode () {
      const { code, message } = await sendPhoneCode()
      if (+code !== 0) {
        danger(message)
      }
    },

    async getUserData () {
      const { data } = await queryUserInfo()
      this.formData.phone = data.userId || {}
    },

    async queryConfig () {
      const { code, data } = await queryOpenPhoneMessage()

      if (+data !== 1 && +code === 0) {
        this.$router.replace('/checkIdentify2')
      }
    },

    async handlerCheck () {
      const { code, message, data } = await checkPhoneCode({ verifyCode: this.formData.yzm })

      if (+code === 0 && data) {
        this.$router.replace('/checkIdentify2')
      } else {
        danger(message)
      }
    },
  },
}
